export const LIST = "GAME_VENDOR_LIST";
export const DROPDOWN = "GAME_VENDOR_DROPDOWN";
//export const UPDATE_STATUS = "GAME_VENDOR_UPDATE_STATUS";
export const STORE = "GAME_VENDOR_STORE";
export const DETAILS = "GAME_VENDOR_DETAILS";
// export const UPDATE = "GAME_VENDOR_UPDATE";
